var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-roles-wellcome"},[_c('r-icon',{attrs:{"name":"list","size":64}}),_c('r-title',{attrs:{"type":"title-2","align":"center"}},[_vm._v(" Выберите роль в списке, чтобы посмотреть информацию и настроить ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }